import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  onDark?: boolean;
  size?: "sm" | "md" | "lg";
}

export function Logo({ className, onDark = false, size = "md" }: LogoProps) {
  const sizeClass = size === "sm" ? "h-7" : size === "lg" ? "h-12" : "h-9";
  return (
    <div className={cn("flex items-center", className)}>
      <img
        src="/logo-ccap.png"
        alt="CredCapital"
        className={cn(sizeClass, "w-auto")}
        style={onDark ? { filter: "brightness(0) invert(1)" } : undefined}
      />
    </div>
  );
}
